import { useState } from "react";
import { KioskMealMenuPreviewFragment } from "../../../../types";
import { OrderConfirmationScreen } from "../OrderConfirmationScreen";
import { GuestOrderBanner } from "./GuestOrderBanner";
import { GuestModal } from "./GuestModal";
import { SelectMenuModal } from "./SelectMenuModal";
import { GuestOrderForm } from "./GuestOrderForm";
import { GuestErrorScreen } from "./GuestErrorScreen";
import { GuestOrderState } from "./types";

interface GuestOrderFlowProps {
  mealMenus: readonly KioskMealMenuPreviewFragment[];
}

export const GuestOrderFlow = ({ mealMenus }: GuestOrderFlowProps) => {
  const [guestModalOpen, setGuestModalOpen] = useState(false);
  const [state, setState] = useState<GuestOrderState>(null);

  const guestOrderingEnabled = mealMenus.some(mm => mm.isGuestOrderingEnabled);

  const handleReset = () => {
    setGuestModalOpen(false);
    setState(null);
  };

  if (!guestOrderingEnabled) {
    return null;
  }

  return (
    <>
      <GuestOrderBanner onOrderAsGuest={() => setGuestModalOpen(true)} />
      <GuestModal
        open={guestModalOpen}
        onClose={handleReset}
        onGuestResolved={guest => {
          setGuestModalOpen(false);
          if (mealMenus.length === 1) {
            setState({ step: "order", guest, selectedMealMenu: mealMenus[0] });
          } else {
            setState({ step: "selectMenu", guest });
          }
        }}
      />
      {state?.step === "selectMenu" && (
        <SelectMenuModal
          open
          onClose={handleReset}
          menus={mealMenus}
          onSelectMenu={selectedMealMenu => setState({ step: "order", guest: state.guest, selectedMealMenu })}
        />
      )}
      {state?.step === "order" && (
        <GuestOrderForm
          open
          onClose={handleReset}
          guest={state.guest}
          mealMenu={state.selectedMealMenu}
          onOrderPlaced={({ orderCode, pickupTime }) =>
            setState({
              step: "confirmation",
              orderCode,
              pickupTime,
              smsPhoneLast4: state.guest.smsOptIn ? state.guest.phoneNumber.replace(/\D/g, "").slice(-4) : null,
              mealMenuTimezone: state.selectedMealMenu.timezone,
            })
          }
          onError={() => setState({ step: "error" })}
        />
      )}
      {state?.step === "confirmation" && (
        <OrderConfirmationScreen
          open
          orderCode={state.orderCode}
          pickupTime={state.pickupTime}
          smsPhoneLast4={state.smsPhoneLast4}
          mealMenuTimezone={state.mealMenuTimezone}
          onBackToMenu={handleReset}
        />
      )}
      {state?.step === "error" && <GuestErrorScreen open onBackToMenu={handleReset} />}
    </>
  );
};
